import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface TimezoneOnboardingState {
  isOpen: boolean;
}

export const TimezoneOnboardingStore = signalStore(
  { providedIn: 'root' },

  withState<TimezoneOnboardingState>({
    isOpen: false,
  }),

  withMethods((store) => ({
    open(): void {
      patchState(store, { isOpen: true });
    },

    close(): void {
      patchState(store, { isOpen: false });
    },
  })),
);
